import { render, staticRenderFns } from "./PayslipSummaryComponent.vue?vue&type=template&id=5bb281f5&scoped=true"
import script from "./PayslipSummaryComponent.vue?vue&type=script&lang=js"
export * from "./PayslipSummaryComponent.vue?vue&type=script&lang=js"
import style0 from "./PayslipSummaryComponent.vue?vue&type=style&index=0&id=5bb281f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb281f5",
  null
  
)

export default component.exports